import { useRef, useEffect, useCallback, useState } from 'react'
import { InputText } from 'ui_kit_qmd'
import { useLocation } from 'react-router-dom'
import CountryPicker from 'react-phone-input-2'
import moment from 'moment-timezone'
import { styles, text } from './Constants'
import './PatientInformation.scss'
import 'react-phone-input-2/lib/high-res.css'
import backArrow from '../../../../images/common/back-arrow.png'
import { PatientResultItem } from './components/patient-result-item/PatientResultItem'
import { NO_RESULTS_TEXT, RESCHEDULE_VISIT_PAGE_PATH } from '../../../../utils/constants'
import { getAddressStringFromAddressObject, getAge } from '../../../../utils/common'
import { DATE_FORMAT_SLASH } from '../../../../utils/dateUtils'
import { useInitialPatientInformation } from '../../hooks/useInitalPatientInformation'
import { ProviderTile } from '../visit-information/components/provider-tile/ProviderTile'
import { noop } from 'lodash'

export const PatientInformation = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  searchChanged,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  searchResults,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientSelected,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsSearchActive,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  fullNameError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  show,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  provider,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitOptions,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  timeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTimeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTime,
}) => {
  const [providerName, setProviderName] = useState('--')
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const [titles, setTitles] = useState('--')
  const { pathname } = useLocation()
  const isReschedulePage = pathname === RESCHEDULE_VISIT_PAGE_PATH

  const {
    patientFullNameInitial,
    dobTextInitial,
    emailTextInitial,
    addressTextInitial,
    phoneNumberTextInitial,
    phoneCountryInitial,
    phoneCountryCodeInitial,
  } = useInitialPatientInformation()

  const dobText = useRef(dobTextInitial)
  const emailText = useRef(emailTextInitial)
  const addressText = useRef(addressTextInitial)
  const phoneNumberText = useRef(phoneNumberTextInitial)
  const phoneCountry = useRef(phoneCountryInitial)
  const phoneCountryCode = useRef(phoneCountryCodeInitial)

  const countryPickerContainerStyle = {
    ...styles.COUNTRY_PICKER_CONTAINER_STYLE,
    width: phoneCountryCode.current.length * 12 + 75,
  }

  const countryPickerInputStyle = {
    ...styles.COUNTRY_PICKER_INPUT_STYLE,
    width: phoneCountryCode.current.length * 12 + 75,
  }

  const [fullName, setFullName] = useState(patientFullNameInitial)

  useEffect(() => {
    if (!provider) {
      return
    }
    const { Prefix, FirstName, LastName, Suffix } = { ...provider }
    setProviderName(
      provider.FirstName ?
        `${Prefix || ''} ${FirstName} ${LastName} ${Suffix || ''}`.trim()
      : provider.providerName || '--',
    )
    if (provider?.ProfessionalTitles?.length) {
      setTitles(() => {
        let titleString = ''
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        provider.ProfessionalTitles?.map((pro, index) => {
          if (index === provider.ProfessionalTitles.length - 1) {
            titleString += pro
          } else {
            titleString += `${pro}; `
          }
        })
        return titleString
      })
    }
  }, [provider])

  useEffect(() => {
    if (show) {
      const arrow = document.querySelector('.arrow')
      const formControl = document.querySelector('.form-control')
      const selectedFlag = document.querySelector('.selected-flag')

      const countryCode = document.createElement('span')
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      const controlText = document.createTextNode(`+${formControl.value.slice(1)}`)
      countryCode.classList.add('new-visit-phone-country-code')
      countryCode.appendChild(controlText)

      const arrowImg = document.createElement('img')
      arrowImg.src = backArrow
      arrowImg.classList.add('new-visit-phone-country-button-arrow')

      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      arrow.appendChild(arrowImg)
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      selectedFlag.appendChild(countryCode)

      const coutryCode = document.querySelector('.new-visit-phone-country-code')
      const button = document.querySelector('.react-tel-input .selected-flag')
      const arrow2 = document.querySelector('.react-tel-input .selected-flag .arrow')

      const computedButtonWidth = phoneCountryCode.current.length * 12 + 75
      const computedArrowMargin = phoneCountryCode.current.length * 12 + 15

      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      coutryCode.innerHTML = `+${phoneCountryCode.current}`
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      button.style.width = `${computedButtonWidth}px`
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      arrow2.style.marginLeft = `${computedArrowMargin}px`
    }
  }, [show])

  useEffect(() => {
    if (show) {
      const coutryCode = document.querySelector('.new-visit-phone-country-code')
      const button = document.querySelector('.react-tel-input .selected-flag')
      const arrow = document.querySelector('.react-tel-input .selected-flag .arrow')

      const computedButtonWidth = phoneCountryCode.current.length * 12 + 75
      const computedArrowMargin = phoneCountryCode.current.length * 12 + 15

      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      coutryCode.innerHTML = `+${phoneCountryCode.current}`
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      button.style.width = `${computedButtonWidth}px`
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      arrow.style.marginLeft = `${computedArrowMargin}px`
    }
  }, [phoneCountryCode.current, show])

  const onSelectItem = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (patient) => {
      dobText.current = `${moment(patient.BirthDate).format(DATE_FORMAT_SLASH)} (${getAge(
        patient.BirthDate,
      )}/${patient.Gender === 'male' ? 'M' : 'F'})`
      emailText.current = patient.Email
      addressText.current = getAddressStringFromAddressObject(patient?.Address)
      phoneNumberText.current = patient.PhoneNumber.Number.slice(patient.PhoneNumber.Prefix?.length)
      phoneCountry.current = patient.PhoneNumber?.CountryCode.toLowerCase() || 'us'
      phoneCountryCode.current = patient.PhoneNumber?.Prefix.slice(1) || '1'
      const patientName = `${patient.FirstName} ${patient.LastName}`
      setFullName(patientName)
      patientSelected({
        ...patient,
        fullName: patientName,
        dobAge: dobText.current,
        address: addressText.current,
        phoneNumber: `+${phoneCountryCode.current} ${phoneNumberText.current}`,
      })
    },
    [patientSelected],
  )
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetFullName = (value) => {
    if (emailText.current) {
      dobText.current = ''
      emailText.current = ''
      addressText.current = ''
      phoneNumberText.current = ''
      phoneCountry.current = 'us'
      phoneCountryCode.current = '1'
    }
    setFullName(value)
    searchChanged(value)
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSubmit = useCallback((e) => {
    e.preventDefault()
  }, [])

  if (!show) {
    return null
  }
  return (
    <div className='new-visit-patient-information-container' style={{ height: provider ? '608px' : '440px' }}>
      <label htmlFor='null' className='new-visit-patient-information-title'>
        {text.PATIENT_INFORMATION}
      </label>
      {!isReschedulePage && (
        <label htmlFor='null' className='new-visit-patient-information-search-by'>
          {text.SEARCH_BY_BLURB}
        </label>
      )}
      <div className='new-visit-patient-information-input-row'>
        <div className='new-visit-patient-information-search-container'>
          {}
          <form onSubmit={onSubmit}>
            <InputText
              containerStyle={styles.FULL_NAME_INPUT_STYLE}
              label={text.PATIENT_NAME}
              setValue={onSetFullName}
              value={fullName}
              view='visitType'
              isSearch
              onSetIsFocused={setIsSearchActive}
              errorImgStyle={styles.INPUT_ERROR_STYLE}
              isDisableAutocomplete
              localError={fullNameError}
              disabled={isReschedulePage}
            />
          </form>
          {searchResults ?
            searchResults?.length > 0 ?
              <div className='new-visit-patient-information-search-list-container'>
                {/*
                 // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
                {searchResults.map((result, index) => (
                  <PatientResultItem result={result} selectItem={onSelectItem} isLast={result?.length === index + 1} />
                ))}
              </div>
            : <div className='new-visit-patient-information-search-list-container'>
                <label htmlFor='null' className='new-visit-patient-information-no-results-label'>
                  {NO_RESULTS_TEXT}
                </label>
              </div>

          : null}
        </div>

        <InputText
          containerStyle={styles.INPUT_STYLE}
          view='visitType'
          label={text.DOB}
          value={dobText.current}
          errorImgStyle={styles.INPUT_ERROR_STYLE}
          setValue={noop}
          disabled
        />
      </div>
      <div className='new-visit-patient-information-input-row'>
        <div className='new-visit-patient-information-phone-container'>
          <div className='new-visit-country-picker-container'>
            <CountryPicker
              country={phoneCountry.current}
              enableSearch
              containerStyle={countryPickerContainerStyle}
              inputStyle={countryPickerInputStyle}
              buttonStyle={styles.COUNTRY_PICKER_BUTTON_STYLE}
              dropdownStyle={styles.COUNTRY_PICKER_DROPDOWN_STYLE}
              buttonClass='new-visit-phone-country-button'
              onChange={() => {}}
            />

            <InputText
              containerStyle={styles.PHONE_INPUT_STYLE}
              label={text.PHONE_NUMBER}
              view='visitType'
              type='number'
              value={phoneNumberText.current}
              errorImgStyle={styles.INPUT_ERROR_STYLE}
              setValue={noop}
              disabled
            />
          </div>
        </div>
        <InputText
          containerStyle={styles.INPUT_STYLE}
          view='visitType'
          label={text.EMAIL}
          value={emailText.current}
          errorImgStyle={styles.INPUT_ERROR_STYLE}
          setValue={noop}
          disabled
        />
      </div>
      <InputText
        containerStyle={styles.ADDRESS_STYLE}
        label={text.ADDRESS}
        view='visitType'
        value={addressText.current}
        errorImgStyle={styles.INPUT_ERROR_STYLE}
        setValue={noop}
        disabled
      />
      {provider ?
        <>
          <label htmlFor='null' className='reschedule-visit-information-title'>
            {text.CURRENT_VISIT}{' '}
          </label>
          {/*
           // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
          <ProviderTile
            visitTypeName={visitOptions.visitType}
            method={visitOptions.method}
            isReschedule={provider}
            imageUrl={provider.ImageUrl}
            providerName={providerName}
            timeZone={timeZone}
            visitTimeZone={visitTimeZone}
            visitTime={visitTime}
          />
        </>
      : null}
    </div>
  )
}
